import React from 'react'

const SvgPuzzle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M14.5 12.218c0-1.572-1.5-2-1.5-2v-3h2.226s.537 1.571 2.15 1.571 2.151-1.571 2.151-1.571H21a1 1 0 011 1v7a1 1 0 01-1 1h-1.473s-.538 1.571-2.15 1.571c-1.613 0-2.151-1.571-2.151-1.571H13v-2s1.5-.429 1.5-2zM2 15.218v-7a1 1 0 011-1h1s.5-1.5 2-1.5 2 1.5 2 1.5h2v2.994s1.5.404 1.5 2.006c0 1.602-1.5 2-1.5 2v2H8s-.5-1.5-2-1.5-2 1.5-2 1.5H3a1 1 0 01-1-1z' />
  </svg>
)

export default SvgPuzzle
